import Loader from "@/javascript/components/loader"

const bindCountryEligibleLabel = (content) => {
  const select = content.querySelector('.country-select')
  const target = content.querySelector('label[for="job_country_eligible_only"]')
  if(select && typeof(select.selectize) != 'undefined') {
    select.selectize.on('item_add', (value, item) => {
      target.innerHTML = target.innerHTML.replace(/\:(.*)$/, `: ${item[0].innerHTML}`)
    })
  }
}

const bindNonEligibleApplicationSubmit = (content) => {
  const eligibleButton = content.querySelector('#application_country_eligible_true')
  const nonEligibleButton = content.querySelector('#application_country_eligible_false')
  const buttons = [eligibleButton, nonEligibleButton]

  buttons.forEach((button) => {
    if(button) {
      button.addEventListener('click', (e) => {
        nonEligibleButton.form.submit.disabled = nonEligibleButton.checked
      })
    }
  })

  if(eligibleButton && eligibleButton.form) {
    eligibleButton.form.submit.disabled = !eligibleButton.checked
  }
}

Loader.functional((content, resolve) => {
  if(document.querySelector('.js-country-eligible-only-wrapper')){
    bindCountryEligibleLabel(content)
  }

  if(document.querySelector('.js-country-eligible-container')) {
    bindNonEligibleApplicationSubmit(content)
  }

  resolve()
})
